(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var T13 = {
        brakD:  __pewniaki_inline_cfg[0],
        brakZ:  __pewniaki_inline_cfg[1],
        brakO:  __pewniaki_inline_cfg[2],
        niska:  __pewniaki_inline_cfg[3],
        niskie: __pewniaki_inline_cfg[4],
        niskich:__pewniaki_inline_cfg[5],
        wysoka: __pewniaki_inline_cfg[6],
        wysokie:__pewniaki_inline_cfg[7],
        wysokich:__pewniaki_inline_cfg[8],
        raz:    __pewniaki_inline_cfg[9],
        razy:   __pewniaki_inline_cfg[10],
        losU:   __pewniaki_inline_cfg[11],
        losA:   __pewniaki_inline_cfg[12],
        zdMod:  __pewniaki_inline_cfg[13],
        brakMod:__pewniaki_inline_cfg[14],
        jeden:  __pewniaki_inline_cfg[15],
        wiele:  __pewniaki_inline_cfg[16],
        kraje:  __pewniaki_inline_cfg[17],
        krajeM: __pewniaki_inline_cfg[18],
        krajeB: __pewniaki_inline_cfg[19],
        srednia:__pewniaki_inline_cfg[20],
        srModel:__pewniaki_inline_cfg[21],
        srBrak: __pewniaki_inline_cfg[22],
        najOpis:__pewniaki_inline_cfg[23],
        krOpis: __pewniaki_inline_cfg[24]
    };
    function odmiana(n, jeden, kilka, wiele) {
        if (n === 1) return jeden;
        var d = n % 10, s = n % 100;
        return (d >= 2 && d <= 4 && (s < 12 || s > 14)) ? kilka : wiele;
    }
    function uklad(r, typuje) {
        return (typuje - r) + ' ' + odmiana(typuje - r, T13.niska, T13.niskie, T13.niskich) + ' + ' + r + ' ' + odmiana(r, T13.wysoka, T13.wysokie, T13.wysokich);
    }
    // Model jest dostepny tylko dla liczby; null, brak klucza i pusty napis to brak, nie zero.
    function jestLiczba(v) {
        return v !== null && v !== undefined && v !== '' && typeof v !== 'boolean' && typeof v !== 'object' && isFinite(Number(v));
    }
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var f2 = function (v) { return v == null ? '—' : (Math.round(v * 100) / 100).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var razy = function (n) { return n === 1 ? T13.raz : T13.razy; };
    var losowan = function (n) { return n === 1 ? T13.losU : T13.losA; };

    // Jedno przeliczenie dla wnioskow i renderu, zeby obie drogi dawaly te same liczby.
    function licz(o, dane) {
        var A = window.PEWNIAKI_ANALIZA;
        var typuje = dane.typuje || A.typuje, hist = o.wysokie || {}, mod = ((dane || {}).model || {}).wysokie || {};
        var w = { N: o.losowan || 0, typuje: typuje, hist: hist, mod: mod, naj: null, najIle: 0, sumaR: 0, srMod: 0, kraje: 0, krajeMod: 0, pelnyMod: true, krajeModOk: true, najMod: null };
        for (var r = 0; r <= typuje; r++) {
            var ile = Number(hist[r]) || 0, ma = jestLiczba(mod[r]), p = ma ? Number(mod[r]) : 0;
            w.sumaR += r * ile;
            if (ma) { w.srMod += r * p; } else { w.pelnyMod = false; }
            if (ile > w.najIle) { w.naj = r; w.najIle = ile; }
            if (r === 0 || r === typuje) {
                w.kraje += ile;
                if (ma) { w.krajeMod += p; } else { w.krajeModOk = false; }
            }
        }
        if (w.naj != null && jestLiczba(mod[w.naj])) { w.najMod = Number(mod[w.naj]); }
        return w;
    }

    window.PEWNIAKI_ANALIZA = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[25] + '/analizy/struktura.json',
        wersja: __pewniaki_inline_cfg[26],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[27] + '/lata/',
        pula:   JSON.parse(String(__pewniaki_inline_cfg[28])),
        typuje: JSON.parse(String(__pewniaki_inline_cfg[29])),
        // Zakres lat: suma SUROWYCH licznikow `wysokie` z rocznikow (plan V2 §5.3).
        sumujLata: function (roczniki) {
            var hist = {}, N = 0;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.wysokie || {}).forEach(function (s) { hist[s] = (hist[s] || 0) + r.wysokie[s]; });
            });
            return { losowan: N, wysokie: hist };
        },
        wnioski: function (o, klucz, dane) {
            if (!o) return [T13.brakD];
            var w = licz(o, dane || {});
            if (!w.N || w.naj == null) return [T13.brakZ];
            var pHist = w.najIle * 100 / w.N;
            var zdMod = w.najMod != null
                ? T13.zdMod.replace('%1', f1(w.najMod * 100)).replace('%2', f1(Math.abs(pHist - w.najMod * 100)))
                : T13.brakMod;
            var zdHist = w.N === 1
                ? T13.jeden.replace('%1', uklad(w.naj, w.typuje))
                : T13.wiele.replace('%1', tys(w.N)).replace('%2', uklad(w.naj, w.typuje)).replace('%3', tys(w.najIle)).replace('%4', razy(w.najIle)).replace('%5', f1(pHist));
            return [
                zdHist + zdMod,
                T13.kraje.replace('%1', tys(w.kraje)).replace('%2', losowan(w.kraje)).replace('%3', tys(w.N)).replace('%4', f1(w.kraje * 100 / w.N))
                    + (w.krajeModOk ? T13.krajeM.replace('%1', f1(w.krajeMod * 100)) : T13.krajeB),
                T13.srednia.replace('%1', f2(w.sumaR / w.N)).replace('%2', tys(w.N))
                    + (w.pelnyMod ? T13.srModel.replace('%1', f2(w.srMod)) : T13.srBrak)
            ];
        },
        render: function (okno, klucz, dane) {
            var q = function (s) { return document.querySelector(s); };
            var sekcja = q('[data-niskie-wysokie]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var w = licz(okno, dane || {}), N = w.N;
            q('[data-niskie-wysokie-n]').textContent = tys(N);
            q('[data-niskie-wysokie-naj]').textContent = w.naj != null ? uklad(w.naj, w.typuje) : '—';
            q('[data-niskie-wysokie-naj-opis]').textContent = (N && w.naj != null)
                ? T13.najOpis.replace('%1', tys(w.najIle)).replace('%2', razy(w.najIle)).replace('%3', f1(w.najIle * 100 / N)).replace('%4', w.najMod != null ? f1(w.najMod * 100) + '%' : '—')
                : T13.brakO;
            q('[data-niskie-wysokie-kraje]').textContent = N ? tys(w.kraje) : '—';
            q('[data-niskie-wysokie-kraje-opis]').textContent = N
                ? T13.krOpis.replace('%1', f1(w.kraje * 100 / N)).replace('%2', w.krajeModOk ? f1(w.krajeMod * 100) + '%' : '—')
                : T13.brakO;
            q('[data-niskie-wysokie-srednia]').textContent = N ? f2(w.sumaR / N) : '—';
            q('[data-niskie-wysokie-srednia-model]').textContent = w.pelnyMod ? f2(w.srMod) : '—';
            var wiersze = [];
            for (var r = 0; r <= w.typuje; r++) {
                var ile = Number(w.hist[r]) || 0, maMod = jestLiczba(w.mod[r]), p = maMod ? Number(w.mod[r]) : 0;
                wiersze.push('<tr><td>' + uklad(r, w.typuje) + '</td><td class="liczbowa">' + tys(ile) + '</td><td class="liczbowa">'
                    + (N ? f1(ile * 100 / N) + '%' : '—') + '</td><td class="liczbowa">' + (maMod ? f1(p * 100) + '%' : '—')
                    + '</td><td class="liczbowa">' + (maMod ? f1(N * p) : '—')
                    + __pewniaki_inline_cfg[30] + (N ? Math.round(ile * 100 / N) : 0) + '" ></div></div></td></tr>');
            }
            q('[data-niskie-wysokie-tabela] tbody').innerHTML = wiersze.join('');
        }
    };
})();
})();
